import { Pipe, PipeTransform } from '@angular/core';
import { Service } from '../models/service';

@Pipe({ 
  standalone: false,
  name: 'serviceFilter' 
})

export class FilterServiceNamePipe implements PipeTransform {
  transform(items: Service[] | null, searchText: string): Service[] {
    if (!searchText) return items!;

    return items!.filter((service: any) =>
      service.name.toLowerCase().includes(searchText?.toLowerCase()),
    );
  }
}
